module.exports = __webpack_public_path__ + "img/sample3-voronoi.7fb30e6f.png";